module.exports = __webpack_public_path__ + "img/16.f5d2e811.jpg";